const statusList = [
  { key: "未出租", value: "未出租" },
  { key: "已出租", value: "已出租" },
];

export { statusList };
